import { useState } from "react";

// styles and images
import "../project/Project.css";
import Close from "../../assets/close.svg";

// components and global
import {
  companyStore,
  messageAndErrorStore,
  projectStore,
  userStore,
} from "../../store/Store";

//components
import FormButton from "../../formComponents/FormButton";
import InputField from "../../formComponents/InputField";

// funcs
import { getFormattedDate, parseDateInCentral } from "../../funcs/helperFuncs";

// hooks
import { useVerifyUnique } from "../../hooks/useVerifyUnique";
import { useNavigate } from "react-router-dom";
import { useEscape } from "../../hooks/useEscape";

export default function GenerateInvoice({ setTriggerInvoice, isAsset }) {
  // global
  const currentUser = userStore((data) => data.currentUser);
  const JwtToken = userStore((data) => data.JwtToken);
  const setAuthStatus = userStore((data) => data.setAuthStatus);
  const currentCompany = userStore((data) => data.currentCompany);
  const currentProject = projectStore((data) => data.currentProject);
  const projectCustomerInvoices = projectStore(
    (data) => data.projectCustomerInvoices,
  );
  const setProjectCustomerInvoices = projectStore(
    (data) => data.setProjectCustomerInvoices,
  );
  const setProjectCustomerInvoiceTotals = projectStore(
    (data) => data.setProjectCustomerInvoiceTotals,
  );
  const setInvoiceCounts = companyStore((data) => data.setInvoiceCounts);
  const toggleNewMessage = messageAndErrorStore(
    (data) => data.toggleNewMessage,
  );

  // local
  const [pending, setPending] = useState(false);
  const [generateVendorBackups, setGenerateVendorBackups] = useState(false);
  const [customerInvoice, setCustomerInvoice] = useState({
    id: 0,
    customer_id: 0,
    project_id: currentProject.project.id,
    invoice_name: "",
    company_id: currentCompany.id,
    is_asset: isAsset,
    start_date: null,
    end_date: null,
    loads_start: null,
    loads_end: null,
    created_by_id: currentUser.id,
    updated_by_id: currentUser.id,
  });

  const navigate = useNavigate();
  const { exists } = useVerifyUnique(
    projectCustomerInvoices,
    "invoice_name",
    customerInvoice.invoice_name,
    "",
  );

  const handleClose = () => {
    setTriggerInvoice(false);
  };

  useEscape(setTriggerInvoice, [], [], pending);

  const handleChange = (e) => {
    setCustomerInvoice({
      ...customerInvoice,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setPending(true);
    if (exists) {
      toggleNewMessage(
        "This invoice already exists, please update the name/version",
      );
      setPending(false);
      return;
    }
    var reqBody = customerInvoice;

    reqBody.start_date = getFormattedDate(reqBody.start_date);
    reqBody.end_date = getFormattedDate(reqBody.end_date);
    reqBody.loads_start = parseDateInCentral(reqBody.start_date, false);
    reqBody.loads_end = parseDateInCentral(reqBody.end_date, true);

    if (reqBody.start_date >= reqBody.end_date) {
      toggleNewMessage("The end date must be greater than the start date.");
      setPending(false);
      return;
    }

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + JwtToken);
    const controller = new AbortController();
    const requestOptions = {
      method: "POST",
      headers,
      body: JSON.stringify(reqBody),
      signal: controller.signal,
    };

    fetch(
      `${process.env.REACT_APP_BACKEND}/pc/customer-invoice/${customerInvoice.id}?generate_vendor_backups=${generateVendorBackups}`,
      requestOptions,
    )
      .then((res) => {
        if (res.status === 401) {
          navigate("/login");
          setAuthStatus(false);
        } else {
          setAuthStatus(true);
          return res.json();
        }
      })
      .then((data) => {
        if (data.error) {
          if (data.message === "project is archived and cannot be updated") {
            toggleNewMessage("Project is Archived and cannot be updated");
            setPending(false);
            return;
          }
          toggleNewMessage("Something went wrong");
          setPending(false);
        } else {
          setProjectCustomerInvoices(data.invoices);
          setProjectCustomerInvoiceTotals(data.invoice_totals);
          setInvoiceCounts(data.invoice_counts);
          setTriggerInvoice(false);
          setPending(false);
          toggleNewMessage(null, "Invoice Added");
        }
      })
      .catch((_) => {
        toggleNewMessage("Something went wrong");
        setPending(false);
      })
      .finally(() => setPending(false));
    return () => controller.abort();
  };
  return (
    <div className="popup">
      <div className="popup-inner">
        {!pending && (
          <div className="close">
            <img onClick={handleClose} src={Close} alt="close" />
          </div>
        )}
        <h3>Generate Customer Invoice</h3>
        <form onSubmit={handleSubmit}>
          <InputField
            type={"text"}
            name={"invoice_name"}
            title={"Invoice Name"}
            placeholder={"Name of Invoice"}
            onChange={handleChange}
            value={customerInvoice.invoice_name}
            required={true}
          />
          <div className="row mb-4">
            <InputField
              divClass={"col"}
              type={"date"}
              name={"start_date"}
              title={"Start"}
              onChange={handleChange}
              required={true}
            />
            <InputField
              divClass={"col"}
              type={"date"}
              name={"end_date"}
              title={"End"}
              onChange={handleChange}
              required={true}
            />
          </div>
          <div className="row mb-3">
            <label className="col-sm-5 fw-bold" htmlFor="generate_vendor_backups">
              Generate Vendor Backups
            </label>
            <div className="col-auto">
              <input
                id="generate_vendor_backups"
                type="checkbox"
                value={generateVendorBackups}
                checked={generateVendorBackups}
                onChange={() => setGenerateVendorBackups(!generateVendorBackups)}
                className="form-check-input"
                style={{ borderColor: "black" }}
              />
            </div>
          </div>
          <FormButton name={"Submit"} pending={pending} />
        </form>
      </div>
    </div>
  );
}
